import { render } from "./Widget4.vue?vue&type=template&id=876672c8&ts=true"
import script from "./Widget4.vue?vue&type=script&lang=ts"
export * from "./Widget4.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__